import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import sortDown from '../../resources/images/png/sort-down@2x.png'
import { getCurrency } from "../../services/cities";

const base = "overview-table";

@inject("RiderStore")
@observer
class OverviewTable extends Component {
  state = {
    data: null
  };
  
  handleSort = (name) => {
    this.setState({[name]: !this.state[name]})
  }
  
  sortDownStyling = (name) => {
    let styling = {
      height: "11px", 
      width: "8px", 
      marginLeft: "10px"
    }
    
    if (this.state[name]) {
      styling.transform = 'rotate(180deg) scaleX(-1)'
    }

    return styling
  } 
  
  render() {
    const { RiderStore } = this.props;
            
    const columns = [
      {
        id: "name",
        Header: <div><span>Rider name</span>{this.state.isSorting === 'name' && <img src={sortDown} className="sort-down" style={this.sortDownStyling('name')} alt="Down arrow icon"/>}</div>,
        accessor: d => <span>{d.name}</span>
      },
      {
        Header: <div><span>Phone number</span>{this.state.isSorting === 'phone' && <img src={sortDown} className="sort-down" style={this.sortDownStyling('phone')} alt="Down arrow icon"/>}</div>,
        accessor: "phone"
      },
      {
        id: "dispatches",
        Header: <div><span>Dispatches</span>{this.state.isSorting === 'dispatches' && <img src={sortDown} className="sort-down" style={this.sortDownStyling('dispatches')} alt="Down arrow icon"/>}</div>,
        accessor: d => <span>{d.dispatches ? d.dispatches.join(', ') : null}</span>
      },
      {
        Header: <div><span>Backup</span>{this.state.isSorting === 'backup' && <img src={sortDown} className="sort-down" style={this.sortDownStyling('backup')} alt="Down arrow icon"/>}</div>,
        id: "backup",
        accessor: d => {
          return d.backup 
          ? <div><i className="fas fa-check-circle" style={{color: "#18d665"}} /></div>
          : <div><i className="fas fa-times-circle" style={{color: "red"}}/></div>

        }
      },
      {
        id: "returned_cash",
        Header: <div onClick={() => this.handleSort('returned_cash')}><span>Returned Cash</span>{this.state.isSorting === 'returned_cash' && <img src={sortDown} className="sort-down" style={this.sortDownStyling('returned_cash')} alt="Down arrow icon"/>}</div>,
        accessor: d => <span>{getCurrency()}{d.returned_cash}</span>
      },
      {
        Header: <div><span>Check-in Time</span>{this.state.isSorting === 'checked_in_at' && <img src={sortDown} className="sort-down" style={this.sortDownStyling('checked_in_at')} alt="Down arrow icon"/>}</div>,
        id: "checked_in_at",
        accessor: d => {
          var date = new Date(d.checked_in_at);
          var hours = date.getHours();
          var minutes = "0" + date.getMinutes();
          var seconds = "0" + date.getSeconds();
          var formattedTime =
            hours + ":" + minutes.substr(-2) + ":" + seconds.substr(-2);
          return <span>{formattedTime}</span>;
        }
      },
      {
        id: "status",
        Header: "Status",
        accessor: d => (
          <Link to={`check-in/${d.attendance_id}`} className="link--no-underline">
            <div
              className="update-button link--no-underline"
              onClick={this.editRider}
            >
              Update
            </div>
          </Link>
        )
      }
    ];
    return (
      <div className={`${base} text--left`}>
        <div className="bg--white">
          <ReactTable
            data={RiderStore.displayedRiders}
            columns={columns}
            className="table -highlight"
            minRows="0"
            showPagination={true}
            loading={RiderStore.loading}
            noDataText="No riders found."
            defaultPageSize={100}
            onSortedChange={(newSorted, column, shiftKey) => {
              this.setState({ isSorting: column.id })
              this.handleSort(column.id)
            }}
            // filterable={true}
          />
        </div>
      </div>
    );
  }
}

export default OverviewTable;



// WEBPACK FOOTER //
// ./src/components/overview/OverviewTable.js